/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
    object, func, shape, string, array,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { useQuery } from '@apollo/client';
import mbpLogger from '@module-logger/mbp';

import { getBrand } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import findSkuById from '../../../../../gql/queries/findSkuById';
import GenericSkeleton from '../../../../../components/GraphqlComponents/GraphqlSkeletonComponents/GenericSkeleton';
import { isEmpty } from '../../../utils/object';
import SubscriptionDropDown from './SubscriptionDropDown';
import ErrorDialog from '../../Subscriptions/Dialogs/ErrorDialog';

const styles = (theme) => ({
    errorText: {
        color: 'red',
        fontWeight: '400',
    },
    errorCloseBtn: {
        color: theme.palette.white,
        backgroundColor: theme.palette.primaryButton,
        alignSelf: 'center',
    },
});

const FrequencyDuration = ({
    classes, subscription, enableEditButton, subscriptions, brandColor,
}) => {
    const brand = useSelector(getBrand);
    const [hasError, setHasError] = useState(false);
    const productSku = `${subscription?.brand}-${subscription?.productId}`;

    const query = findSkuById(brand.domain, productSku, 'subscriptionsList { interval, duration, type } ');
    const { error, data, loading } = useQuery(query);

    if (loading || !data) {
        return <GenericSkeleton height="120px" width="25%" />;
    }

    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            jsError: error,
            message: `Failed to fetch CSM subscriptionsList data: content type findSkuById - query - ${query}`,
        });
        return (
            <ErrorDialog
                classes={classes}
                openModal={hasError}
                errorMessage="We are sorry, there seems to be a technical issue, please try again"
                closeModal={() => setHasError(false)}
            />
        );
    }

    let subscriptionsList = {};
    if (data) {
        subscriptionsList = data?.findSkuById?.subscriptionsList;
    }

    if (isEmpty(subscriptionsList)) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            jsError: error,
            message: `CSM SubscriptionsList data is empty, no frequency options found ${subscriptionsList}`,
        });
        return <div className={classes.errorText}>We are sorry, unable to fetch Frequency & Duration. Please try again later.</div>;
    }

    return (
        <SubscriptionDropDown
            brandColor={brandColor}
            enableEditButton={enableEditButton}
            fieldLabel="Frequency"
            subscription={subscription}
            subscriptionsList={subscriptionsList}
            subscriptions={subscriptions}
        />
    );
};

FrequencyDuration.defaultProps = {
    subscription: {},
};
FrequencyDuration.propTypes = {
    classes: object.isRequired,
    subscription: shape({
        productId: string,
        brand: string,
    }),
    enableEditButton: func.isRequired,
    subscriptions: array.isRequired,
    brandColor: string.isRequired,
};

export default withStyles(styles)(FrequencyDuration);
